module.exports = __webpack_public_path__ + "static/media/payment-methods.4a9adf37.svg";